<template>
  <div class="template-modal-page">
    <MultiStepModal
      header="Header"
      :total-steps="steps.length"
      :step="step"
      @update:step="val => (step = val)"
      @close="handleClose"
      @finish="handleFinish"
    >
      <template #content="{ step: currentStep }">
        <div
          v-for="(s, idx) in steps"
          v-show="currentStep === idx + 1"
          :key="'step-' + (idx + 1)"
          class="page"
        >
          <p class="heading--large">
            {{ s.header }}
          </p>
          <p class="body--medium">
            {{ s.body }}
          </p>
        </div>
      </template>
    </MultiStepModal>
  </div>
</template>

<script>
import MultiStepModal from '@/components/template/multiStepModal/index.vue'

export default {
  name: 'TemplateMultiStepModalPage',
  components: { MultiStepModal },
  data: () => ({
    step: 1,
    steps: [
      { header: 'Header 1', body: 'Body' },
      { header: 'Header 2', body: 'Body' },
      { header: 'Header 3', body: 'Body' }
    ]
  }),
  methods: {
    handleClose () { this.step = 1 },
    handleFinish () { this.step = 1 }
  }
}
</script>

<style lang="scss">
.template-modal-page {
  width: 100%;
  height: 100vh;
  background: rgb(103, 100, 100);

  .page {
    @include stack-space($space-small);
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}
</style>
